import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { confirmAlert } from 'react-confirm-alert';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import * as actions from '../../redux/actions/actions-testimonial';
import Button from '../../components/Button';
import SearchBar from '../../components/SearchBar';
import BreadCrumb from '../../components/Breadcrumb';
import Loader from '../../components/Loader';

class Testimonial extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchVal: ''
    };
    props.getTestimonialList();
  }


  deleteTestimonial = (id) => {
    confirmAlert({
      title: 'Delete Testimonial',
      message: 'Are you sure to delete the Testimonial?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            this.props.deleteTestimonial(id)
              .then(() => {
                toast.success('Deleted Successfully');
              }).catch((error) => {
                toast.error(error.message);
              });
          }
        },
        {
          label: 'No'
        }
      ]
    });
  }

  handleTableFilter = (search) => {
    this.setState({ searchVal: search });
  }

  setTableOption = () => (this.props.testimonialList && this.props.tableLoading ? <Loader /> : 'No Data Found');

  render() {
    const searchVal = this.state.searchVal.toLowerCase();
    const testimonial = this.props.testimonialList.filter((item) => item.StudentName.toLowerCase().includes(searchVal));

    const columns = [{
      dataField: 'StudentName',
      text: 'Student Name'
    }, {
      dataField: 'StudentPicURL',
      text: 'Student Pic URL'
    }, {
      dataField: 'CreatedDateTime',
      text: 'Created at',
      formatter: (cell, row) => (
        new Date(cell).toLocaleDateString()
      ),
      sort: true
    }, {
      dataField: 'Id',
      text: 'Actions',
      headerStyle: {
        width: '140px'
      },
      formatter: (cell, row) => (
        <>
          <span
            role="presentation"
            className="fa fa-pencil-alt tableEdit"
            onClick={() => this.props.history.push(`/testimonial-editor/${cell}`)}
          />
          <span
            role="presentation"
            className="fa fa-trash tableDelete"
            onClick={() => this.deleteTestimonial(cell)}
          />
        </>
      )
    }];

    const defaultSorted = [{
      dataField: 'CreatedDateTime',
      order: 'desc'
    }];

    return (
      <div>
        <div className="container">
          <BreadCrumb currentPage="Testimonial" />
          <div className="col-md-12 py-3 mb-5">
            <div className="card border-secondary">
              <div className="card-header">
                <div className="row">
                  <div className="col-md-10">
                    {/* <span className="fa fa-quote-left cardTitle"> Testimonial</span> */}
                    <SearchBar
                      placeholder="Search by Student Name"
                      handleChange={(e) => this.handleTableFilter(e.target.value)}
                    />
                  </div>
                  <div className="col-md-2 text-right">
                    <Button
                      className="btn btn-sm btn-secondary"
                      onClick={() => this.props.history.push('/testimonial-editor/0')}
                    >
                      <span className="fas fa-plus" />
                      {' '}
                      Add New
                    </Button>
                  </div>
                </div>
              </div>
              <div className="card-body text-secondary">
                <BootstrapTable
                  keyField="Id"
                  data={testimonial}
                  columns={columns}
                  pagination={paginationFactory()}
                  defaultSorted={defaultSorted}
                  noDataIndication={() => this.setTableOption()}
                  hover
                />

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Testimonial.defaultProps = {
  tableLoading: false,
  testimonialList: null,
  getTestimonialList: null,
  deleteTestimonial: null
};

Testimonial.propTypes = {
  tableLoading: PropTypes.bool,
  testimonialList: PropTypes.array,
  getTestimonialList: PropTypes.func,
  deleteTestimonial: PropTypes.func
};

const mapStateToProps = ({ testimonial }) => ({
  tableLoading: testimonial.tableLoading,
  testimonialList: testimonial.testimonialList
});

const mapDispatchToProps = (dispatch) => ({

  getTestimonialList: () => dispatch(actions.fetchTestimonial()),
  deleteTestimonial: (id) => dispatch(actions.deleteTestimonial(id))

});

export default connect(mapStateToProps, mapDispatchToProps)(Testimonial);
